"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var CarouselPaginator =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(CarouselPaginator, _PureComponent);

  function CarouselPaginator() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CarouselPaginator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CarouselPaginator)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onClick", function (index) {
      _this.props.onItemClick(index);
    });
    return _this;
  }

  (0, _createClass2.default)(CarouselPaginator, [{
    key: "_renderChildren",
    value: function _renderChildren() {
      var _this2 = this;

      var _this$props = this.props,
          currentIndex = _this$props.currentIndex,
          children = _this$props.children;
      return _react.Children.map(children, function (page, i) {
        var classes = (0, _classnames.default)(page.props.className, currentIndex === i ? 'CarouselPage-selected' : '');
        return (0, _react.cloneElement)(page, {
          className: classes,
          onClick: _this2._onClick.bind(_this2, i)
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          containerRef = _this$props2.containerRef;
      var classes = (0, _classnames.default)('CarouselPaginator', className);
      return _react.default.createElement("div", {
        className: classes,
        ref: containerRef
      }, this._renderChildren());
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return CarouselPaginator;
}(_react.PureComponent);

exports.default = CarouselPaginator;
(0, _defineProperty2.default)(CarouselPaginator, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The function for assigning the ref to access this element. */
  containerRef: _propTypes.default.func,

  /** The content to insert into the carousel paginator. */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired,

  /**
   * Do not set outright, this is passed in from the Carousel component.
   *
   * @ignore
   */
  onItemClick: _propTypes.default.func,

  /**
   * Do not set outright, this is passed in from the Carousel component.
   *
   * @ignore
   */
  currentIndex: _propTypes.default.number
});
(0, _defineProperty2.default)(CarouselPaginator, "defaultProps", {
  currentIndex: 0
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CarouselPaginator, "CarouselPaginator", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Carousel/CarouselPaginator.jsx");
  leaveModule(module);
})();

;